import axios from 'axios';
import AccessToken from '@/services/auth-central';
import signature  from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.API_BASE_URI;
const ZEROBOUNCE_URL = process.env.API_ZEROBOUNCE_URL;
const ZEROBOUNCE_KEY = process.env.API_ZEROBOUNCE_KEY;


let config = {
    headers: {
        Authorization: 'Bearer ' + ACCESS_TOKEN.token
    }
};

let configZerobounce = {
    transformRequest: (data, headers) => {
        delete headers.common['Authorization'];
        return data;
    }
};

class Auth {
    async getReferFriends(queryString) {
        return await axios.get(BASE_URI + '/v1/auth/referfriends' + queryString, config);
    }
    async createReferLink(data) {
        return await axios.post(BASE_URI + '/v1/auth/create-refer-link', data, config);
    }
    async User() {
        return await axios.get(BASE_URI + '/v1/auth/user', config);
    }
    async postUser(data) {
        return await axios.post(BASE_URI + '/v1/auth/user', data, config);
    }
    async getAccess(queryString = '') {
        return await axios.get(BASE_URI + '/v1/auth/getaccess' + queryString, config);
    }
    async getStores(queryString = '') {
        return await axios.get(BASE_URI + '/v2/stores' + signature(queryString), config);
    }
    async getDevices() {
        return await axios.get(BASE_URI + '/v1/devices', config);
    }
    async getTokens() {
        return await axios.get(BASE_URI + '/v1/tokens', config);
    }
    async getUser(queryString = '') {
        return await axios.get(BASE_URI + '/v1/auth/getuser' + queryString , config);
    }
    async changepassword(data) {
        return await axios.post(BASE_URI + '/v1/auth/changepassword', data, config);
    }

    async logOut(data = []) {
        return await axios.post(BASE_URI + '/v1/auth/logout',data,config);
    }

    async logoutOtherDevices(data = []) {
        return await axios.post(BASE_URI + '/v1/auth/logoutOtherDevices',data,config);
    }

    async logoutAllDevices(data = []) {
        return await axios.post(BASE_URI + '/v1/auth/logoutAllDevices',data,config);
    }

    async sendVerify(data) {
        return await axios.post(BASE_URI + '/v1/auth/email/send', data, config);
    }

    async emailSendVerifyV2(data) {
      return await axios.post(BASE_URI + '/v2/auth/email/send/verify'  + signature(), data, config);
    }

    async sendVerifySms(data) {
        return await axios.post(BASE_URI + '/v1/auth/sms/send', data, config);
    }
    async isblacklistEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/blacklist/' + data, config);
    }
    async iswhitelistEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/whitelist/' + data, config);
    }
    async isRegisteredEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/registered/' + data, config);
    }
    async getZeroBouunceEmail(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/zerobounce/' + data, config);
    }
    async isEmailValid(data) {
        return await axios.get(BASE_URI + '/v1/auth/email/emailvalid/' + data, config);
    }
    async isEmailValidV2(data) {
        return await axios.get(BASE_URI + `/v2/auth/email/emailvalid/${data}` + signature(), config);
    }
    async isUniquePhoneNumber(data) {
        return await axios.get(BASE_URI + '/v1/auth/phone/registered/' + data, config);
    }
    async forgotPassword(data) {
        return await axios.post(BASE_URI + '/v1/auth/password/forgot', data, config);
    }
    async resetPassword(data) {
        return await axios.post(BASE_URI + '/v1/auth/password/reset', data, config);
    }
    async checkEmailAndPhone(data) {
        return await axios.post(BASE_URI + '/v1/auth/checkEmailAndPhone', data, config);
    }
    async updateEmailAndPhone(data) {
        return await axios.post(BASE_URI + '/v1/auth/updateEmailAndPhone', data, config);
    }
    async socialCallback(provider,queryString = nul){
        try {
            return await axios.get(BASE_URI + `/v1/auth/${provider}/callback?${queryString}`, config)
        } catch (err) {
            return err.response;
        }
    }
    async socialAppleActions(queryString){
        try {
            return await axios.get(BASE_URI + `/v1/apple/actions?${queryString}`, config)
        } catch (err) {
            return err.response;
        }
    }
    async getLineStatus(token) {
        return await axios.get(BASE_URI + '/v1/auth/line/status/' + token, config);
    }
    async isUniqueReferFriend(data) {
        return await axios.get(BASE_URI + '/v1/auth/user/refercode/' + data, config);
    }
    async referCode(querystring = ''){
        return await axios.get(BASE_URI + '/v1/auth/refercode' + querystring, config);
    }
    async hasReferbyByEmail(email) {
        return await axios.get(BASE_URI + '/v1/auth/referby/has/' + email , config);
    }
    async getCheckCoupon(querystring = ''){
        return await axios.get(BASE_URI + '/v1/auth/coupon/check' + querystring, config);
    }
    async getNameSocialByFacebookUrl(url) {
        return await axios.get(BASE_URI + '/v1/auth/facebook?url=' + url, config);
    }
    async getUserProfile(queryString = '') {
        return await axios.get(BASE_URI + '/v1/auth/getuserprofile' + queryString , config);
    }
}

class SocialAccount {
    async getSocialAccount(){
        try {
            return await axios.get(BASE_URI + `/v1/central/social-account`, config)
        } catch (err) {
            return err.response;
        }
    }
    async deleteSocialAccount(data){
        try {
            return await axios.delete(BASE_URI + `/v1/central/social-account/${data}`, config)
        } catch (err) {
            return err.response;
        }
    }
}


class Tenant {
    async getStatus(tenantId) {
        return await axios.get(BASE_URI + '/v1/tenant/' + tenantId + '/getstatus', config);
    }

    async getTotalStores() {
        return await axios.get(BASE_URI + '/v2/stores/total-store' + signature(), config);
    }

    async createStore(data) {
        // return await axios.post(BASE_URI + '/v1/tenants', data, config);
        return await axios.post(BASE_URI + '/v2/tenants'  + signature(), data, config);
    }

    async leaveStore(tenantId, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/' + tenantId + '/leave', data, config);
    }

    async getStoreDetail(tenantId) {
        return await axios.get(BASE_URI + '/v1/central/tenant/' + tenantId + '/detail', config);
    }

    async sendVerify(tenantId, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/' + tenantId + '/email/send', data, config);
    }

    async sendVerifySMS(tenantId, data) {
        return await axios.post(BASE_URI + '/v1/central/tenant/' + tenantId + '/sms/send', data, config);
    }

    async deleteStore(tenantId, data = null) {
        return await axios.put(BASE_URI + '/v1/central/tenant/' + tenantId + '/delete', data, config);
    }

    async getPromotionItemCoupon(tenantId, options = {}) {
        const response = await axios.get(BASE_URI + '/v1/central/tenant/' + tenantId + '/promotion-item-coupon', config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getPlanSubscription(tenantId, options = {}) {
        const response = await axios.get(BASE_URI + '/v1/central/tenant/' + tenantId + '/subscription', config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async getStoreHasPermission(tenantId, querystring) {
        return await axios.get(BASE_URI + '/v1/central/tenant/' + tenantId + '/has-permission' + querystring, config);
    }

    async getPlanFeature(queryString) {
        try{
            const response = await axios.get(BASE_URI + '/v2/tenants/content' + signature(queryString), config);
            return response;
        } catch (err){
            return err.response;
        }
    }
}

class Domain {
    async checkDomain(domain) {
        let querystring = '?domain='+domain;
        return await axios.get(BASE_URI + '/v1/has/domain' + querystring, config);
    }

    async postAddSubDomain(data) {
        return await axios.post(BASE_URI + '/v1/central/domain/create-subdomain', data, config);
    }
}
class Analytics {
    async facebook(data) {
        return await axios.post(BASE_URI + '/v1/facebook/event', data, config);
    }
}

class Customer {
    async checkPhone(mobile) {
        let querystring = '?mobile='+mobile;
        return await axios.get(BASE_URI + '/v1/has/customer' + querystring, config);
    }

    async checkEmail(data) {
        return await axios.get(BASE_URI + '/v1/central/customer/checkemail/' + data, config);
    }
}

class User {
    async countdownChangePassword() {
        return await axios.get(BASE_URI + '/v1/central/user/countdownChangePassword', config);
    }
    async addSecondaryEmail(userId, data) {
        return await axios.post(BASE_URI + '/v1/central/user/'+ userId +'/addsecondaryemail', data, config);
    }
    async getUserByid(userId) {
        return await axios.get(BASE_URI + '/v1/central/user/' + userId , config);
    }
    async getUser(querystring = ''){
        return await axios.get(BASE_URI + '/v1/central/user' + querystring, config);
    }

    async getUserV2(querystring = ''){
        return await axios.get(BASE_URI + '/v2/user/me' + signature(querystring), config);
    }

    async sendVerifyMailDeleteAccount(data) {
        return await axios.post(BASE_URI + '/v1/central/user/email/send', data, config);
    }
    async sendVerifySmsDeleteAccount(data) {
        return await axios.post(BASE_URI + '/v1/central/user/sms/send', data, config);
    }
    async deleteAccount(userId) {
        return await axios.delete(BASE_URI + '/v1/central/user/delete/account/' + userId, config);
    }
}

class Invitation {
    async getInvitationList(querystring = '') {
        return await axios.get(BASE_URI + '/v1/central/invitation' + querystring, config);
    }
    async postAcceptInvitaion(invitationId, data = {}) {
        const response = await axios.post(BASE_URI + '/v1/central/invitation/' + invitationId, data, config);
        return response;
    }
    async deleteInvitaion(invitationId) {
        const response = await axios.delete(BASE_URI + '/v1/central/invitation/' + invitationId, config);
        return response;
    }
    async getInvitationListV2(querystring = '') {
        return await axios.get(BASE_URI + '/v2/invitation' + signature(querystring), config);
    }
}

class Address {
    async getAddressJson() {
        return await axios.get(BASE_URI + '/v1/address-json', config);
    }
}

class Country {
    async getCountry($data) {
        return await axios.get(BASE_URI + '/v1/central/country'+$data, config);
    }
}

class Industry {
    async getIndustry($data) {
        return await axios.get(BASE_URI + '/v1/central/industry'+$data, config);
    }
}

class Password {
    async Timechangepassword(data) {
        return await axios.get(BASE_URI + '/v1/central/password/changepasswordat/' + data, config);
    }
    async changepassword(data) {
        return await axios.put(BASE_URI + '/v1/central/password/changepassword', data, config);
    }
}

class Email {
    async getEmailZeroBounce(data) {
        return await axios.get(ZEROBOUNCE_URL + '/v2/validate?api_key=' + ZEROBOUNCE_KEY + '&email=' + data, configZerobounce);
    }
}

class BroadCast {
    async socialLinkAccount(provider,data){
        try {
            return await axios.post(BASE_URI + `/v1/${provider}/cancel`,{data}, config)
        } catch (err) {
            return err.response;
        }
    }
}

class Billing {
    async getBillingHistory(tenantIds, querystring = '') {
        return await axios.get(BASE_URI + '/v1/central/billing/' + tenantIds + '/getBillingList' + querystring, config);
    }

    async postOrder(data) {
        const response = await axios.post(BASE_URI + '/v1/central/billing', data, config);
        return response;
    }
}

class Plan {
    async getPlan(data, options = {}){
        const response = await axios.get(BASE_URI + '/v1/central/plan' + data, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
    async getPlanById(id, options = {}){
        const response = await axios.get(BASE_URI + '/v1/central/plan/' + id, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }
}

class PremiumSubscription {
    async getPlanSubscription(tenantIds, options = {}) {
        const response = await axios.get(BASE_URI + '/v1/central/premium-subscription/' + tenantIds, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async postOrder(tenantIds, data) {
        const response = await axios.post(BASE_URI + '/v1/central/premium-subscription/' + tenantIds + '/order', data, config);
        return response;
    }
}

class Coupon {
    async getCoupon(querystring = '', options = {}) {
        const response = await axios.get(BASE_URI + '/v1/central/coupon' + querystring, config);
        if (options.dataReady) {
            return response.data.data;
        }
        return response;
    }

    async postCoupon(coupon) {
        const response = await axios.post(BASE_URI + '/v1/central/coupon', coupon, config);
        return response;
    }
}

class WithholdingTax {
    async getWithholdingTax() {
        const response = await axios.get(BASE_URI + '/v1/central/withholding-tax', config);
        return response;
    }
}

class AppVersions {
    async checkMigrate(tenantId){
        try {
            return await axios.get(BASE_URI + `/v2/app-version/migrate/${tenantId}` + signature(), config);
        } catch (err) {
            return err.response;
        }
    }

    async upGradeVersion(tenantId){
        try {
            return await axios.post(BASE_URI + `/v2/app-version/upgrade-patch/${tenantId}` + signature(), null, config)
        } catch (err) {
            return err.response;
        }
    }
}

class Setting {
    async getSetting(queryString = '') {
        const response = await axios.get(BASE_URI + '/v1/central/setting' + queryString, config);
        return response;
    }
}

class Announcement {
    async getAnnouncement() {
        const response = await axios.get(BASE_URI + '/v1/central/announcement/show', config);
        return response;
    }
    async acceptAnnouncement(id, data = '') {
        const response = await axios.post(BASE_URI + '/v1/central/announcement/' + id, data, config);
        return response;
    }
}

export default {
    Auth: new Auth(),
    Invitation: new Invitation(),
    Address: new Address(),
    Email: new Email(),
    Password: new Password(),
    Tenant: new Tenant(),
    Domain: new Domain(),
    Country: new Country(),
    Industry: new Industry(),
    Customer: new Customer(),
    User: new User(),
    Analytics: new Analytics(),
    BroadCast: new BroadCast(),
    SocialAccount: new SocialAccount(),
    ACCESS_TOKEN: ACCESS_TOKEN.token,
    Plan: new Plan(),
    PremiumSubscription: new PremiumSubscription(),
    Coupon: new Coupon(),
    Billing: new Billing(),
    WithholdingTax: new WithholdingTax(),
    AppVersions: new AppVersions(),
    Setting: new Setting(),
    Announcement: new Announcement(),
}



// WEBPACK FOOTER //
// ./src/services/endpoint/central.service.js